import { ImageType } from "@nova/constants"
import { OrthoImage } from "@nova/protobuf"
import {
    booleanValidator,
    entityValidator,
    enumValidator,
    idValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
} from "../util"

export const createOrthoImageValidator = entityValidator(OrthoImage, {
    id: { validators: idValidators, nonNull: true },
    longitude: { validators: longitudeValidators, nonNull: true },
    latitude: { validators: latitudeValidators, nonNull: true },
    altitude: { validators: [], nonNull: true },
    height: { validators: [] },
    pitch: { validators: [] },
    yaw: { validators: [] },
    roll: { validators: [] },
    takenAt: { validators: [], nonNull: true },
    fov: { validators: [], nonNull: true },
    size: { validators: [], nonNull: true },
    focalLength: { validators: [] },
    make: { validators: [] },
    imageWidth: { validators: [] },
    imageHeight: { validators: [] },
    imageType: { validators: enumValidator("imageType", ImageType) },
    hasLRF: { validators: booleanValidator("hasLRF") },
})

export const updateOrthoImageValidator = entityValidator(OrthoImage, {})

export const getDefaultOrthoImageCreateArgs = () => ({})

export type CreateOrthoImageArgs = UnionToTuple<keyof typeof createOrthoImageValidator>
export type UpdateOrthoImageArgs = UnionToTuple<keyof typeof updateOrthoImageValidator>
